import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";
// GeneralViews
import NotFound from "@/pages/NotFoundPage.vue";

// Admin pages
import LoginPage from "@/login/LoginPage.vue";
import PasswordReset from "@/login/PasswordReset.vue";
import PasswordResetWithToken from "@/login/PasswordResetWithToken.vue";
import Dashboard from "@/pages/Dashboard.vue";
import GestionSiniestrosColaborador from "@/pages/Siniestros/GestionSiniestrosColaborador.vue";
import MisPolizasColaborador from "@/pages/Polizas/MisPolizasColaborador.vue";
import RecibosDeUnaPoliza from "@/pages/Recibos/RecibosDeUnaPoliza.vue";
import UserProfile from "@/pages/UserProfile.vue";
import Notifications from "@/pages/Notifications.vue";
import Icons from "@/pages/Icons.vue";
import Maps from "@/pages/Maps.vue";
import Typography from "@/pages/Typography.vue";
import TableList from "@/pages/TableList.vue";

const routes = [
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/dashboard",
    children: [
      {
        path: "dashboard",
        name: "Intranet del colaborador. Jla Asociados, Correduría de Seguros S.A.",
        component: Dashboard
      },
      {
        path: "siniestros",
        name: "Gestión de Siniestros",
        component: GestionSiniestrosColaborador
      },
      {
        path: "siniestros/:id",
        name: "Gestión de Siniestros",
        component: GestionSiniestrosColaborador
      },
      {
        path: "siniestros/:siniestro",
        name: "Gestión de Siniestros",
        component: GestionSiniestrosColaborador
      },
      {
        path: "polizas",
        name: "Mis Pólizas",
        component: MisPolizasColaborador
      },
      {
        path: "recibos",
        name: "Mis Recibos",
        component: RecibosDeUnaPoliza
      },
      {
        path: "recibos/:id",
        name: "Mis Recibos",
        component: RecibosDeUnaPoliza
      },
      {
        path: "stats",
        name: "stats",
        component: UserProfile
      },
      {
        path: "notifications",
        name: "notifications",
        component: Notifications
      },
      {
        path: "icons",
        name: "icons",
        component: Icons
      },
      {
        path: "maps",
        name: "maps",
        component: Maps
      },
      {
        path: "typography",
        name: "typography",
        component: Typography
      },
      {
        path: "table-list",
        name: "table-list",
        component: TableList
      },
    ]
  },
  {path: '/login', component: LoginPage},
  {path: '/password-reset', name: 'password-reset', component: PasswordReset},
  {
    path: '/reset-password',
    name: 'reset-password',
    component: PasswordResetWithToken,
    props: route => ({ token: route.query.token })
  },
  {path: "*", component: NotFound}
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;
